var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEllipsisVertical = function SvgEllipsisVertical(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 6.66671C10.9166 6.66671 11.6666 5.91671 11.6666 5.00004C11.6666 4.08337 10.9166 3.33337 9.99992 3.33337C9.08325 3.33337 8.33325 4.08337 8.33325 5.00004C8.33325 5.91671 9.08325 6.66671 9.99992 6.66671ZM9.99992 8.33337C9.08325 8.33337 8.33325 9.08337 8.33325 10C8.33325 10.9167 9.08325 11.6667 9.99992 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08337 10.9166 8.33337 9.99992 8.33337ZM9.99992 13.3334C9.08325 13.3334 8.33325 14.0834 8.33325 15C8.33325 15.9167 9.08325 16.6667 9.99992 16.6667C10.9166 16.6667 11.6666 15.9167 11.6666 15C11.6666 14.0834 10.9166 13.3334 9.99992 13.3334Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEllipsisVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ellipsis-vertical.e5366b9be32bb0173a8b19a58afdaf6e.svg";